import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const navigateToField = e => {
  const anchorID = e.target.getAttribute('href').replace('#', '');
  const tabContent = document.querySelector('.tab-content');
  const anchor = tabContent.querySelector(`[id="${anchorID}"]`);
  if (anchor) {
    const tabPane = anchor.closest('.tab-pane');
    if (tabPane) {
      const tabLinkID = tabPane.id.replace('tabpane', 'tab');
      const tabLink = document.getElementById(tabLinkID);
      tabLink?.click();
      setTimeout(() => {
        const formcontrol = anchor.querySelector('[id]');
        formcontrol?.focus();
      }, 1);
    }
  }
};

// Contains any errors and missing field warnings to display
const ErrorMessage = ({ item }) => {
  const [fieldName] = useMemo(() => Object.keys(item), [item]);
  const labelName = useMemo(() => {
    if (fieldName.includes('Rooms.')) {
      const [rest, splitFieldName] = fieldName.split(/\.(?=[^\.]+$)/); //eslint-disable-line
      // eslint-disable-next-line
      return splitFieldName.split(/(?=[A-Z])/).join(' ');
    }
    return fieldName;
  }, [item]);
  return (
    <li className="list-group-item" key={fieldName}>
      <a
        href={`#${fieldName}`}
        onClick={navigateToField}
      >
        {`${labelName}: `}
      </a>
      <span>{`${item[fieldName]}`}</span>
    </li>
  );
};

ErrorMessage.propTypes = {
  item: PropTypes.objectOf(PropTypes.string),

};

export default ErrorMessage;
